@if (errorTriggered()) {
    <div class="ap-margin-3">
        <ap-notification status="error"> Error on mijn-omgeving contact page is triggered! </ap-notification>
    </div>
}

<div>
    currentEnv: {{ currentEnv() }}
    <button (click)="toggleEnv()">Switch to {{ currentEnv() === 'DEV' ? 'TST' : 'DEV' }}</button>
</div>

<button (click)="openChat()" data-testid="openConversationalDialog">Open Chat</button>

<div>
    <h2>Stuur een berichtje:</h2>
    <button (click)="sendTestMessage('Test')" data-testid="faq-question-01">Test</button>
    <button (click)="sendTestMessage('Mooi')" data-testid="faq-question-02">Mooi</button>
</div>

<mijn-klant-conversational></mijn-klant-conversational>
